import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContratoInserirComponent } from './contrato-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ContratoInserirComponent }
    ])],
    exports: [RouterModule]
})
export class ContratoInserirRoutingModule { }
